import { render, staticRenderFns } from "./word_group_addword.vue?vue&type=template&id=206441d0&scoped=true&"
import script from "./word_group_addword.vue?vue&type=script&lang=js&"
export * from "./word_group_addword.vue?vue&type=script&lang=js&"
import style0 from "./word_group_addword.vue?vue&type=style&index=0&id=206441d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206441d0",
  null
  
)

export default component.exports